import {
    DateField,
    ReferenceField,
    Show,
    TabbedShowLayout,
    TextField,
    RichTextField,
    List,
    Datagrid,
    ReferenceInput,
    AutocompleteInput
 } from 'react-admin';
import icon from '@mui/icons-material/Forum';

const show = () => (
    <Show>
        <TabbedShowLayout>
            <TabbedShowLayout.Tab label="Details">
                <ReferenceField source="session_id" reference="sessions" />
                <TextField source="name" />
                <TextField source="company" />
                <TextField source="role" />
                <DateField source="createdAt" showDate showTime />
                <DateField source="updatedAt" showDate showTime />
            </TabbedShowLayout.Tab>
            <TabbedShowLayout.Tab label="Transcript">
                <RichTextField source="transcript_formatted" label="Transcript" />
            </TabbedShowLayout.Tab>
            <TabbedShowLayout.Tab label="Summary">
                <RichTextField source="summary_formatted" label="Summary" />
            </TabbedShowLayout.Tab>
        </TabbedShowLayout>
    </Show>
);

const eventFilterQuery = searchText => ({ name: `%${searchText}%` });

const formFilters = [
	<ReferenceInput label="Events" source="session_id" reference="sessions" alwaysOn>
		<AutocompleteInput source="name" filterToQuery={eventFilterQuery} />
	</ReferenceInput>
];

const list = () => (
    <List
        exporter={false}
        filters={formFilters}
        >
        <Datagrid>
            <ReferenceField source="session_id" reference="sessions" link={false} />
            <TextField source="name" />
            <TextField source="company" />
            <TextField source="role" />
            <DateField source="createdAt" showDate showTime />
            <DateField source="updatedAt" showDate showTime />
        </Datagrid>
    </List>
);


export const Interview = {
	show,
    list,
    icon
};

export default Interview;